import React from 'react';

import { fg } from '@confluence/feature-gating';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import {
	ANALYTICS_SOURCE,
	BulkSpacePermissionsPage,
} from '@confluence/bulk-permissions/entry-points/BulkPermissions';
import { BulkAccessManagementPage } from '@confluence/bulk-permissions/entry-points/BulkAccess';

export const BulkSpacePermissionsRoute = () =>
	fg('confluence_rbac_spaces_beta_opt_in') ? (
		<BulkAccessManagementPage />
	) : (
		<BulkSpacePermissionsPage />
	);

BulkSpacePermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
